/* eslint-disable no-unused-vars */
import axios from "../../axios";

const state = {
  list: [],
  pagination: {},
  contactDetail: null,
};

const actions = {
  getList({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/contacts?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Detail
   * @param commit
   * @param id
   * @returns {Promise<{}|*>}
   */
  async detail({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/contacts/${id}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * delete multiple
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async deleteMultiple({ commit }, payload) {
    return await axios.post(
      "/user/operations/student-contact/delete-multiple",
      payload,
    );
  },

  async assignMultiple({ commit }, payload) {
    return await axios.post(
      "/user/operations/student-contact/assign-multiple",
      payload,
    );
  },

  async updateStudent({ commit }, { id, payload }) {
    return await axios.put(`/contacts/students/${id}`, payload);
  },

  async transferToStudent({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/contacts/${id}/transfer-to-student`)
        .then((response) => {
          commit("REMOVE_RECORD", id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * set current page
   * @param commit
   * @param page
   */
  setCurrentPage({ commit }, page) {
    commit("SET_CURRENT_PAGE", page);
  },

  /**
   * set per page
   * @param commit
   * @param size
   */
  setPerPage({ commit }, size) {
    commit("SET_PER_PAGE", size);
  },
};

const mutations = {
  SET_LIST(state, data) {
    state.list = data.items;
    state.pagination = data.pagination;
  },
  SET_DETAIL(state, contact) {
    state.contactDetail = contact;
  },
  SET_CURRENT_PAGE(state, page) {
    state.pagination.current_page = page;
  },
  SET_PER_PAGE(state, size) {
    state.pagination.per_page = size;
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const index = state.list.findIndex((u) => u.id === item);
        state.list.splice(index, 1);
      });
    } else {
      const index = state.list.findIndex((u) => u.id === itemId);
      state.list.splice(index, 1);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
